export const STATIONS_SOURCE_LAYER_SCHEMATIC = [
  "stations_labels",
  "stations_polygons",
];

export const SEV_SOURCE_ID = "sev";

export const NOTIFICATIONS_SOURCE_ID = "moco";
export const NOTIFICATION_STYLE_LAYERS_COLLISION_TOPOGRAPHIC = [
  "FanasLine_Train",
];
export const NOTIFICATION_SOURCE_LAYERS_COLLISION_SCHEMATIC = [
  "lines",
  "lines_icons",
  "poi",
  ...STATIONS_SOURCE_LAYER_SCHEMATIC,
  "moco",
];

// Layer property keys
export const LAYER_IS_VALID_EVENT = "isValidEvent";
export const LAYER_STATION_UIC = "stationUic";
export const LAYER_STATION_BANNER = "stationBanner";
export const LayerPropertyKey = {
  IsValidEvent: LAYER_IS_VALID_EVENT,
  StationBanner: LAYER_STATION_BANNER,
  StationUic: LAYER_STATION_UIC,
} as const;
export type LayerPropertyKey =
  (typeof LayerPropertyKey)[keyof typeof LayerPropertyKey];

// Metadata keys
export const STYLE_MD_VARIABLE_KEY = "tralis.variable";
export const STYLE_MD_FILTER_KEY = "tralis.filter";
export const STYLE_MD_LINE_VARIANT_KEY = "tralis.linevariant";
export const STYLE_MD_MOCO_KEY = "tralis.moco";
export const StyleMetadataKey = {
  Filter: STYLE_MD_FILTER_KEY,
  LineVariant: STYLE_MD_LINE_VARIANT_KEY,
  Moco: STYLE_MD_MOCO_KEY,
  Variable: STYLE_MD_VARIABLE_KEY,
} as const;
export type StyleMetadataKey =
  (typeof StyleMetadataKey)[keyof typeof StyleMetadataKey];

// Metadata value
export const STYLE_MD_STATION = "station";
export const STYLE_MD_GREYOUT_MOT = "greyout_mot";
export const STYLE_MD_GREYOUT_LINE = "greyout_line";
export const STYLE_MD_STANDARD_LINE_VARIANT = "Standard";
export const StyleMetadataValue = {
  GreyoutLine: STYLE_MD_GREYOUT_LINE,
  GreyoutMot: STYLE_MD_GREYOUT_MOT,
  StandardLineVariant: STYLE_MD_STANDARD_LINE_VARIANT,
  Station: STYLE_MD_STATION,
} as const;
export type StyleMetadataValue =
  (typeof StyleMetadataValue)[keyof typeof StyleMetadataValue];

// Metadata variables
export const STYLE_MD_BEFORE_LAYER_HIGHLIGHT = "beforeLayerIdForHighlight";
export const STYLE_MD_BEFORE_LAYER_NOTIFICATIONS = "beforeLayerIdForMoco";
export const STYLE_MD_PERIPH_LAYER = "layerIdPeriphLinesIcons";
export const StyleMetadataVariable = {
  BeforeLayerHighlight: STYLE_MD_BEFORE_LAYER_HIGHLIGHT,
  BeforeLayerNotifications: STYLE_MD_BEFORE_LAYER_NOTIFICATIONS,
  PeriphLayer: STYLE_MD_PERIPH_LAYER,
} as const;
export type StyleMetadataVariable =
  (typeof StyleMetadataVariable)[keyof typeof StyleMetadataVariable];

// Elevator states
export const ELEVATOR_AT_LEAST_ONE_UNKNOWN = "AT_LEAST_ONE_UNKNOWN";
export const ELEVATOR_ALL_OPERABLE = "ALL_OPERABLE";
export const ELEVATOR_AT_LEAST_ONE_INOPERABLE = "AT_LEAST_ONE_INOPERABLE";
export const ELEVATOR_ALL_INOPERABLE = "ALL_INOPERABLE";
export const ElevatorState = {
  AllInoperable: ELEVATOR_ALL_INOPERABLE,
  AllOperable: ELEVATOR_ALL_OPERABLE,
  AtLeastOneInoperable: ELEVATOR_AT_LEAST_ONE_INOPERABLE,
  AtLeastOneUnknown: ELEVATOR_AT_LEAST_ONE_UNKNOWN,
} as const;
export type ElevatorState = (typeof ElevatorState)[keyof typeof ElevatorState];

// Track events
export const TRACK_EVENT_CATEGORY_DEPARTURES = "Departures";
export const TRACK_EVENT_CATEGORY_MAP = "Map";
export const TRACK_EVENT_CATEGORY_ROUTE_HEADER = "RouteHeader";
export const TRACK_EVENT_CATEGORY_ROUTE_STOP = "RouteStop";
export const TRACK_EVENT_CATEGORY_VEHICLE_LIST = "VehiclesList";
export const TrackEventCategory = {
  Departures: TRACK_EVENT_CATEGORY_DEPARTURES,
  Map: TRACK_EVENT_CATEGORY_MAP,
  RouteHeader: TRACK_EVENT_CATEGORY_ROUTE_HEADER,
  RouteStop: TRACK_EVENT_CATEGORY_ROUTE_STOP,
  VehiclesList: TRACK_EVENT_CATEGORY_VEHICLE_LIST,
} as const;
export type TrackEventCategory =
  (typeof TrackEventCategory)[keyof typeof TrackEventCategory];

// Debug modes
export const DEBUG_MODE_DEFAULT = "true";
export const DEBUG_MODE_SBM = "sbm";
export const DEBUG_MODES = [DEBUG_MODE_DEFAULT, DEBUG_MODE_SBM];
export const DebugMode = {
  Default: DEBUG_MODE_DEFAULT,
  Sbm: DEBUG_MODE_SBM,
} as const;
export type DebugMode = (typeof DebugMode)[keyof typeof DebugMode];

// Local storage keys
export const LS_UIC_KEY = "tralis.uic";
export const LS_SEARCH_PARAMS_KEY = "tralis.searchParams";
export const LS_BOOKMARKS_KEY = "tralis.bookmarks";
export const LS_SITUATION_COLLAPSED_KEY = "tralis.situationCollapsed";
export const LS_ALL_SITUATIONS_OPEN_KEY = "tralis.areSituationsOpen";

export const LocaleStorageKey = {
  AreSituationsOpen: LS_ALL_SITUATIONS_OPEN_KEY,
  Bookmarks: LS_BOOKMARKS_KEY,
  SearchParams: LS_SEARCH_PARAMS_KEY,
  SituationCollapsed: LS_SITUATION_COLLAPSED_KEY,
  Uic: LS_UIC_KEY,
} as const;

export type LocaleStorageKey =
  (typeof LocaleStorageKey)[keyof typeof LocaleStorageKey];

export const TralisMode = {
  Schematic: "schematic",
  Topographic: "topographic",
} as const;
export type TralisMode = (typeof TralisMode)[keyof typeof TralisMode];
